import {SelectItem} from 'primeng/primeng'

export interface IDepositsColumn {
    field: string,
    header: string,
    style: any,
    show: boolean,
    sort: boolean,
    editable: boolean,
    checked?: boolean,
    disabled: boolean,
}

export class DepositTableHelper {
    public PotentialDepositColumns: IDepositsColumn[]
    public PotentialDepositColumnOptions: SelectItem[]

    constructor() {
        this.generatePotentialDepositColumns()
    }

    isVisible(collection, dtCol) {
        for (let col of collection) {
            if (col.field === dtCol.field) {
                return true;
            }
        }
        return false;
    }

    generateColumnOptions(columns: IDepositsColumn[]): SelectItem[] {
        if (!columns) {
            return null
        }
        let options = []
        for (let col of columns) {
            options.push({label: col.header, value: col});
        }
        return options
    }

    generatePotentialDepositColumns(): void {
        this.PotentialDepositColumns = [
            { field: 'Status', header: 'Confirm?', style: '', sort: false, show: true, editable: false, disabled: false },
            { field: 'Check_CheckDate', header: 'Deposit Date', style: '', sort: true, show: true, editable: true, disabled: false },
            { field: 'Check_CheckNumber', header: 'Check Number', style: '', sort: true, show: true, editable: false, disabled: false },
            { field: 'Check_CheckAmount', header: 'Check Amount', style: { 'text-align': 'right' }, sort: true, show: true, editable: false, disabled: false },
            { field: 'Payer_ShardPayerIdentifier', header: 'Payer Code', style: '', sort: true, show: true, editable: false, disabled: false },
            { field: 'Payer_ShardPayerName', header: 'Payer Name', style: '', sort: true, show: true, editable: false, disabled: false },
            { field: 'RawDataImport_PaymentFileReceivedDate', header: 'Received Date', style: '', sort: true, show: true, editable: false, disabled: false },
            { field: 'RawDataImport_DepositQueueStatus', header: 'Queue Status', style: '', sort: true, show: true, editable: false, disabled: false },
        ]
    }
}



// WEBPACK FOOTER //
// ./src/app/components/confirm-deposit/confirm-deposit.tableHelper.ts